<template>
  <div>
    <i class="glyphicon glyphicon-calendar fa fa-calendar mr-2"></i>
    <span v-if="date">{{ date | dateFormat }}</span>
    <span v-else>{{ $t(placeholder) }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      date: Date,
      placeholder: String
    }
  }
</script>
